class RnSelects {
  #selectElements = [];

  constructor() {
    this.#selectElements = document.querySelectorAll('[data-rn-select]');
  }

  init() {
    if (this.#selectElements.length) {
      this.#selectElements.forEach((select) => {
        const textElement = select.querySelector('[data-rn-select-input]');
        const selectToggle = select.querySelector('[data-rn-select-toggle]');
        const isMultiple = select.hasAttribute('data-multiple');
        const selectedOptions = [];
        const INNER = 24;

        selectToggle.addEventListener('click', () => this.toggleSelect(selectToggle));

        select.querySelectorAll('[data-rn-select-option]').forEach((variant) => {
          variant.addEventListener('change', () => {
            const option = document.querySelector(`label[for="${variant.id}"]`);

            if (isMultiple) {
              if (variant.checked) {
                selectedOptions.push(option);
                textElement.style.height = `${this.getMaxHeight(selectedOptions) + INNER}px`;
              } else {
                const optionIndex = selectedOptions.indexOf(option);
                selectedOptions.splice(optionIndex, 1);
                textElement.style.height = `${this.getMaxHeight(selectedOptions) + INNER}px`;
              }

              if (!selectedOptions.length) {
                textElement.style.height = 'auto';
              }

              selectToggle.style.setProperty('--arrow-bottom', `${textElement.offsetHeight / 2 - INNER / 2}px`);
              textElement.textContent = this.getTextContent(selectedOptions).join(', ');
            } else {
              textElement.textContent = option.textContent;
              textElement.style.height = `${option.offsetHeight + INNER}px`;
              selectToggle.style.setProperty('--arrow-bottom', `${textElement.offsetHeight / 2 - INNER / 2}px`);
              this.toggleSelect(selectToggle);
            }
          });
        });
      });
    }
  }

  getTextContent = (values) => values.map((value) => value.textContent);

  getMaxHeight = (values) => Math.max(...values.map((value) => value.offsetHeight));

  toggleSelect = (select) => {
    const isOpen = select.classList.contains('rn-form__select--open');

    if (!isOpen) {
      if (document.querySelector('.rn-form__select--open')) {
        document.querySelector('.rn-form__select--open').classList.remove('rn-form__select--open');
      }
      select.classList.add('rn-form__select--open');
      document.addEventListener('click', this.#documentClickHandler);
    }
    else {
      select.classList.remove('rn-form__select--open');
      document.removeEventListener('click', this.#documentClickHandler);
    }
  };

  #documentClickHandler = (e) => {
    const target = e.target;
    const clickedSelect = target.closest('[data-rn-select]');

    if (!clickedSelect) {
      const openSelect = document.querySelector('.rn-form__select--open');
      if (openSelect) {
        openSelect.classList.remove('rn-form__select--open');
      }
    }
  };
}

const initRnSelects = () => {
  const selects = new RnSelects();
  selects.init();
};

export { initRnSelects };
